<mat-card-header>
    <mat-card-title>検索結果</mat-card-title>
</mat-card-header>

<mat-card-content class="mat-card-style-kc-search-result">
    <div class="table-responsive">
        <table #table mat-table multiTemplateDataRows [dataSource]="dataSourceSearchResultDisplay" matSort
            #sort="matSort">
            <!-- Checkbox Column -->
            <ng-container matColumnDef="select">
                <th mat-header-cell *matHeaderCellDef class="border-bottom-double"
                    style="width: 5px; text-align: center;">
                    <mat-checkbox [disabled]="isCheckboxDisabled" class="check-box" color="primary"
                        (change)="$event ? this.masterToggle(selectionSearchResultDisplay, dataSourceSearchResultDisplay) : null; onChangeSelection($event, selectionSearchResultDisplay)"
                        [checked]="selectionSearchResultDisplay.hasValue() && isAllSelected(selectionSearchResultDisplay, dataSourceSearchResultDisplay)"
                        [indeterminate]="selectionSearchResultDisplay.hasValue() && !isAllSelected(selectionSearchResultDisplay, dataSourceSearchResultDisplay)">
                    </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let row" style="text-align: center;">
                    <mat-checkbox class="check-box" color="primary" (click)="$event.stopPropagation()"
                        [disabled]="isCheckboxDisabled"
                        (change)="$event ? this.selectionSearchResultDisplay.toggle(row) : null; onChangeSelection($event, selectionSearchResultDisplay)"
                        [checked]="selectionSearchResultDisplay.isSelected(row)">
                    </mat-checkbox>
                </td>
            </ng-container>
            <ng-container matColumnDef="slideadjustmentunitpriceAname">
                <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>スライド調整単価名</th>
                <td mat-cell *matCellDef="let row">{{row.slideadjustmentunitpriceAname}}</td>
            </ng-container>
            <ng-container matColumnDef="applyYm">
                <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>適用年月</th>
                <td mat-cell *matCellDef="let row">{{row.applyYm | dateYmStringSg }}</td>
            </ng-container>
            <ng-container matColumnDef="slideadjustmentunitprice">
                <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>単価[円]</th>
                <td mat-cell *matCellDef="let row" style="text-align:right">{{row.slideadjustmentunitprice |
                    number:'1.4-4'}}
                </td>
            </ng-container>
            <ng-container matColumnDef="oldnewdivision">
                <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>旧新区分</th>
                <td mat-cell *matCellDef="let row">{{row.oldnewdivision}}</td>
            </ng-container>
            <ng-container matColumnDef="slideadjustmentunitpriceExplanation">
                <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>スライド調整単価説明</th>
                <td mat-cell *matCellDef="let row">{{row.slideadjustmentunitpriceExplanation}}</td>
            </ng-container>
            <ng-container matColumnDef="apprvStsAname">
                <th mat-header-cell class="border-bottom-double" *matHeaderCellDef mat-sort-header>ステータス</th>
                <td mat-cell *matCellDef="let row">{{row.apprvStsAname}}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumnsCol; sticky: true;"></tr>
            <tr mat-row class="clickable-mat-row" *matRowDef="let row; columns: displayedColumnsCol"
                (dblclick)="$event ? onDbClickRow(row, $event): null"></tr>
        </table>
        <mat-paginator #paginator [pageSize]="50" [showFirstLastButtons]="true" id="paginator">
        </mat-paginator>
    </div>
    <div class="tw-flex tw-flex-row tw-flex-wrap tw-box-border tw-justify-start tw-items-center tw-content-center">
        <div
            class="tw-flex tw-flex-row tw-box-border tw-justify-start tw-items-center tw-content-center tw-grow tw-shrink tw-basis-full tw-max-w-[30%]">
            <mat-card-actions class="btn_area_left">
                <button *ngIf="isSlideButtonVisible" [disabled]="isSlideButtonDisabled" type="button" mat-raised-button color="primary" class="btn"
                    (click)="onClickSlideOutput()">スライド調整単価一覧表出力</button>
                <button *ngIf="isAdjustButtonVisible" [disabled]="isAdjustButtonDisabled" type="button" mat-raised-button color="primary" class="btn"
                    (click)="onClickAdjustOutput()">調整単位料金一覧表出力</button>
            </mat-card-actions>
        </div>
        <div *ngIf="isAddButtonVisible"
            class="tw-flex tw-flex-row tw-box-border tw-justify-end tw-items-center tw-content-center tw-grow tw-shrink tw-basis-full tw-max-w-[70%]">
            <mat-card-actions class="btn_area_right">
                <button [disabled]="isAddButtonDisabled" type="button" mat-raised-button color="primary" class="btn"
                    (click)="onClickTankaAdd()">追加</button>
            </mat-card-actions>
        </div>
    </div>
</mat-card-content>